import React from 'react'

const ComputerIcon = () => {
  return (
    <svg
      width="28"
      height="34"
      viewBox="0 0 28 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 13C5 11.6193 6.11929 10.5 7.5 10.5H20.5C21.8807 10.5 23 11.6193 23 13V22C23 23.3807 21.8807 24.5 20.5 24.5H15V26H19C19.5523 26 20 26.4477 20 27C20 27.5523 19.5523 28 19 28H9C8.44772 28 8 27.5523 8 27C8 26.4477 8.44772 26 9 26H13V24.5H7.5C6.11929 24.5 5 23.3807 5 22V13ZM8 20.5C7.44772 20.5 7 20.9477 7 21.5C7 22.0523 7.44772 22.5 8 22.5H20C20.5523 22.5 21 22.0523 21 21.5C21 20.9477 20.5523 20.5 20 20.5H8Z"
        fill="#1072EB"
      />
    </svg>
  )
}

export default ComputerIcon
